import React from 'react'
import styled from 'styled-components'
import RoundIcon from '../../../../../../../components/icons/Roundicon'
import { StyledExternalDiv } from '../style'

const HighlightedText = styled.span`
  font-family: 'Plus Jakarta Sans';
  color: rgb(50, 73, 215);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`
const ExternalDiv = () => {
  return (
    <StyledExternalDiv>
      <RoundIcon />
      <HighlightedText>
        The shortlisted candidates are disabled here.
      </HighlightedText>
    </StyledExternalDiv>
  )
}
export default ExternalDiv
